import * as React from 'react';
import { Box, Stack, Paper, Typography } from "@mui/material";
import defColors from 'utils/defColors';
import { none } from 'ol/centerconstraint';
import { transform } from 'ol/proj';

const StatusTypeChip = ({ children, selected, sx}) => {
    return (
        <Paper variant="outlined" sx={{
            position: 'relative', 
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            borderRadius: '16px',
            borderColor: 'transparent',
            minWidth: '168px', 
            height: '66px',
            backgroundColor: defColors.chipSelectedColorFunc(selected),
            color: defColors.chipSelectedfont(selected),
            ...sx,
        }}>
            <Typography 
            variant={selected ? 'h5' : 'h6'} 
            textAlign={'center'}
             sx={sx?.labelSx}>
                {children}
            </Typography>
        </Paper>
    )
}

export const ChipStack = ({ textItems, selectedText , sx, chipSx }) => {
    return (
        <Box sx={sx}>
            <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1.5}>
                {textItems.map((textItem, index) => (
                    <StatusTypeChip key={textItem} selected={textItem === selectedText} sx={chipSx}>
                        {textItem}
                    </StatusTypeChip>
                ))}
            </Stack>
        </Box>
    )
}